import type { AdminRole } from '@/lib/api-admin';
import { SHIPPING_FEE_READ_ROLES } from '@/features/shippingFee/lib/shippingFeeRbac';
import { OVERSEAS_SHIPPING_READ_ROLES } from '@/features/overseasShipping/lib/overseasShippingRbac';

/**
 * 통합 배송 관리 페이지(국내 배송비 + 해외 배송비 탭) 라우트 가드 RBAC.
 *
 * 통합 페이지는 두 도메인 본문을 한 화면에 노출하므로, 라우트 진입 권한은 두 페이지
 * read 역할의 합집합이어야 한다. 현재 두 집합은 SUPER_ADMIN / OPS_ADMIN / MD_MANAGER 로
 * 동일하지만, 어느 한쪽이 변경되더라도 합집합이 유지되도록 파생값으로 계산한다.
 *
 * (개별 탭의 write 게이팅은 각 Section 컴포넌트가 자체 WRITE_ROLES 로 처리하므로,
 *  라우트 가드는 read 합집합만 책임진다.)
 */
export const SHIPPING_MANAGEMENT_READ_ROLES: ReadonlyArray<AdminRole> = Array.from(
  new Set<AdminRole>([...SHIPPING_FEE_READ_ROLES, ...OVERSEAS_SHIPPING_READ_ROLES]),
);
